import styled from 'styled-components';

export const Wrapper = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(244, 239, 230, 0.86);
  backdrop-filter: saturate(1.4) blur(14px);
  -webkit-backdrop-filter: saturate(1.4) blur(14px);
  border-bottom: 1px solid var(--line);
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: var(--maxWidth);
  height: 72px;
  margin: 0 auto;
  padding: 0 var(--gutter);

  > a {
    flex-shrink: 0;
  }
`;
